import React from 'react';
import './styles.css';

import {ReactComponent as EmailIcon} from '../../assets/email-outline.svg';
import {ReactComponent as PhoneIcon} from '../../assets/phone-outline.svg';
import {ReactComponent as FaceIcon} from '../../assets/facebook.svg';
import {ReactComponent as InstaIcon} from '../../assets/instagram.svg';

function Contact() {
    return(
        <div id="contatobig">
            <span id="cotact-title">ENTRE EM CONTATO COM A OUVIDORIA</span>
            <div id="lado">
                <EmailIcon className='icon' />
                <span>ouv.femininaufop@gmail</span>
            </div>
            
            <div id="lado">
                <PhoneIcon className='icon' />
                <span>(31) 98323-3283</span>
            </div>
            
            <div id="lado">
                <FaceIcon className='icon' />
                <span>facebook.com/ouvidoriafemininaufop/</span>
            </div>
            
            <div id="lado">
                <InstaIcon className='icon' />
                <span>instagram: @ouvidoriafeminina</span>
            </div>
        
        </div>
    );
}

export default Contact;